module.exports = __webpack_public_path__ + "images/preview@2x.png?3c461185";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/preview@2x.png
// module id = 681
// module chunks = 7